/** @format */

import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import PropTypes from 'prop-types';
import { getApiUrl } from '../../../../api.ts';

function resolveImageUrl(url) {
  if (url == null || url === '') return null;
  if (typeof url !== 'string') return null;
  if (url.startsWith('http')) return url;
  const base = getApiUrl().replace(/\/$/, '');
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
}

function ImagePreviewDialog({ open, onClose, url, zIndex }) {
  const src = resolveImageUrl(url);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="image-preview-dialog-title"
      sx={zIndex != null ? { zIndex } : undefined}
    >
      <DialogTitle
        id="image-preview-dialog-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >
        Aperçu de l&apos;image
        <IconButton
          aria-label="Fermer"
          onClick={onClose}
          edge="end"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 200,
          bgcolor: 'action.hover',
        }}
      >
        {src ? (
          <Box
            component="img"
            src={src}
            alt=""
            sx={{
              maxWidth: '100%',
              maxHeight: '75vh',
              objectFit: 'contain',
              verticalAlign: 'middle',
            }}
          />
        ) : (
          <Box component="span" sx={{ color: 'text.secondary', py: 4 }}>
            Aucune image disponible.
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

ImagePreviewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string,
  zIndex: PropTypes.number,
};

ImagePreviewDialog.defaultProps = {
  url: null,
  zIndex: null,
};

export default ImagePreviewDialog;
